import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";

let groupArr = [
  { id: 1, name: "Document No" },
  { id: 2, name: "Document Date" },
  { id: 3, name: "Branch" },
  { id: 4, name: "Food Group" }
];

const OpeningReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  let { branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  
  const [group, setGroup] = useState(groupArr[2]);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");

  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null && group !== null) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and group"))}`,
        common_toast
      );
    }
  };

  //get sale inv report
  const getReport = async () => {
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.id
    ) {
      toast.error(`${_t(t("Please select branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    setDataPaginating(true);
    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/get-opening-stock-report";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("branch_id", branch?.id ?? "");
    formData.append("group_by", group.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setGeneratedReport(true);
        setReportData(res.data);
        setDataPaginating(false);
        if (option === "excel") {
          componentRef.current.handleDownload();
        } else {
          thermalPrint();
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const header = [
    { name: "Group Name", key: "group_name" },
    { name: "Document Id", key: "document_identity", gap:1 },
    { name: "Date", render:(item)=> <Moment format="LL">{item.document_date}</Moment>},
    { name: "Branch", key: "branch_name" },
    { name: "Food Group", key: "food_group" },
    { name: "Item Name", key: "item_name" },
    { name: "Qty", key:"qty",},
    { name: "Unit", key:"unit" },
    { name: "Rate", key:"rate" ,total: 1},
    { name: "Amount", key:"amount" ,total: 1},
    { name: "Total", key:"total_amount" ,total: 1},
    { name: "Remarks", key:"remarks"},
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Opening Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={"Opening Report"}
        sheet="sheet 1"
        buttonText="Opening Report"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    {/* spin loading ends */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Opening Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-3">
                           <Select
                            options={branchForSearch || []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(obj) => setBranch(obj)}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a Branch")) + ".."}
                          />
                        </div>
                        <div className="col-2">
                          <Select
                            options={groupArr && groupArr}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={group}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(group) => setGroup(group)}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>
                        <div className="col-1"></div>
                        <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>

                      <ReportExcelPrintGap
                        header={header}
                        generatedReport = {generatedReport}
                        heading={"Opening Report"}
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: "",
                          show: false,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default OpeningReport;
